import {
  Module, VuexModule, Mutation, Action,
} from 'vuex-module-decorators';
import Vue from 'vue';
import API from '@/lib/API';
import {
  Rule, RuleEvent, RuleConditionDefinition, RuleActionDefinition,
} from '@/types';

@Module
export default class Rules extends VuexModule {
  data: Rule[] = []

  eventDefinitions: RuleEvent[] = []

  conditionDefinitions: RuleConditionDefinition[] = []

  actionDefinitions: RuleActionDefinition[] = []

  metadataLoaded = false

  get rules(): Rule[] {
    return this.data;
  }

  get ruleEvents(): RuleEvent[] {
    return this.eventDefinitions;
  }

  get ruleConditionDefinitions(): RuleConditionDefinition[] {
    return this.conditionDefinitions;
  }

  get ruleActionDefinitions(): RuleActionDefinition[] {
    return this.actionDefinitions;
  }

  @Mutation
  setRules({ rules }: { rules: Rule[] }) {
    console.log('mutations:setRules'); // eslint-disable-line no-console

    this.data = rules;

    return Promise.resolve();
  }

  @Mutation
  setRuleMetadata({ events, conditions, actions }: {
    events: RuleEvent[];
    conditions: RuleConditionDefinition[];
    actions: RuleActionDefinition[];
  }) {
    console.log('mutations:setRuleMetadata'); // eslint-disable-line no-console

    this.eventDefinitions = events;
    this.conditionDefinitions = conditions;
    this.actionDefinitions = actions;
    this.metadataLoaded = true;

    return Promise.resolve();
  }

  @Mutation
  updateRuleInList({ rule }: { rule: Rule }) {
    console.log('mutations:updateRuleInList'); // eslint-disable-line no-console

    const index = this.data.findIndex((r) => r.id === rule.id);
    if (index !== -1) {
      Vue.set(this.data, index, rule);
    }

    return Promise.resolve();
  }

  @Action({ rawError: true })
  async fetchRules() {
    console.log('actions:fetchRules'); // eslint-disable-line no-console

    const rules = await API.getRules();

    if (rules instanceof Error) return Promise.reject(rules);

    return this.context.commit('setRules', { rules });
  }

  @Action({ rawError: true })
  async fetchRuleMetadata() {
    console.log('actions:fetchRuleMetadata'); // eslint-disable-line no-console

    if (this.metadataLoaded) return Promise.resolve();

    const [events, conditions, actions] = await Promise.all([
      API.getRuleEvents(),
      API.getRuleConditions(),
      API.getRuleActions(),
    ]);

    if (events instanceof Error) return Promise.reject(events);
    if (conditions instanceof Error) return Promise.reject(conditions);
    if (actions instanceof Error) return Promise.reject(actions);

    return this.context.commit('setRuleMetadata', { events, conditions, actions });
  }

  @Action({ rawError: true })
  async toggleRule({ id }: { id: number }) {
    console.log('actions:toggleRule'); // eslint-disable-line no-console

    const result = await API.toggleRule(id);

    if (result instanceof Error) return Promise.reject(result);

    const rule = this.data.find((r) => r.id === id);
    if (rule) {
      const updatedRule = { ...rule, isActive: !rule.isActive };
      this.context.commit('updateRuleInList', { rule: updatedRule });
    }

    return Promise.resolve();
  }

  @Action({ rawError: true })
  // eslint-disable-next-line @typescript-eslint/camelcase
  async SOCKET_rulesUpdated() {
    console.log('actions:SOCKET_rulesUpdated'); // eslint-disable-line no-console

    return this.context.dispatch('fetchRules');
  }
}
